var exports = {
  "k": "xfd349460--89f51a--container",
  "m": "xfd349460--89f51a--reaction",
};

module.exports = exports;
